import api from './api';

export interface BankListItem {
  bank_id: string;
  name: string;
  short_name: string;
  code: string;
  bin: string;
  swift_code?: string;
  logo: string;
}

interface BankListResponse {
  data: BankListItem[];
  success: boolean;
}

export interface BankNameOption {
  value: string;
  label: string;
}

export function buildBankNameOptions(banks: BankListItem[], currentBankName?: string | null): BankNameOption[] {
  const options = banks.map((bank) => ({
    value: bank.name,
    label: `${bank.short_name || bank.code} - ${bank.name}`,
  }));

  const legacyName = currentBankName?.trim();
  if (legacyName && !options.some((option) => option.value === legacyName)) {
    options.unshift({ value: legacyName, label: legacyName });
  }
  return options;
}

export const bankService = {
  async list(): Promise<BankListItem[]> {
    const response = await api.get<BankListResponse>('/banks');
    return response.data.data;
  },
};
